<template>
  <div class="misc-wrapper">
      <b-link class="brand-logo" :to="{name : 'login'}">
        <b-img :src="appLogoImage" :alt="'Logo ' + appName" width="40" height="40"/>
        <h2 class="brand-text text-primary m-auto pl-1">{{ appName }}</h2>
      </b-link>

    <div class="misc-inner p-2 p-sm-3" v-if="verified == true">
      <div class="w-100 text-center">
        <h2 class="mb-1"> {{$t("Email verified!")}}  </h2>
        <p class="mb-2"> {{$t("Thanks to verify your email. Now you can login!!")}} </p>
        <b-button variant="primary" class="mb-1 btn-sm-block" :to="{ name: 'login' }"> {{$t("Go to login")}} </b-button>
        <b-img fluid :src="imgUrlSuccess" :alt="$t('Email verified!')" />
      </div>
    </div>

    <div class="misc-inner p-2 p-sm-3" v-else>
      <div class="w-100 text-center">
        <h2 class="mb-1"> {{$t("Can't verify your email")}}  </h2>
        <p class="mb-2"> {{$t("There was an error verifying your email. Please try again later")}} </p>
        <b-img fluid :src="imgUrlError" :alt="$t('Can\'t verify your email')" />
      </div>
    </div>

  </div>
</template>

<script>
import { BLink, BImg, BButton } from 'bootstrap-vue'
import store from '@/store/index'
import axios from '@axios'
import { $themeConfig } from '@themeConfig'

export default {
  components: { BLink, BImg, BButton, },
  data() {
    return {
      successImg: require('@/assets/images/pages/verify-email-success.svg'),
      errorImg: require('@/assets/images/pages/verify-email-error.svg'),
      verified: '',
    }
  },
  setup(){
    const { appName, appLogoImage } = $themeConfig.app
    return { appName, appLogoImage, }
  },
  computed: {
    imgUrlSuccess() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.successImg = require('@/assets/images/pages/verify-email-success-dark.svg')
        return this.successImg
      }
      return this.successImg
    },
    imgUrlError() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.errorImg = require('@/assets/images/pages/verify-email-error-dark.svg')
        return this.errorImg
      }
      return this.errorImg
    }
  },
  beforeMount() {
    axios
        .post('/verify-email', { link: this.$route.query.link })
        .then(response =>
            this.verified = true
        )
        .catch(error =>
            this.verified = false
        )
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-misc.scss';
</style>
